<script lang="ts" setup>
import { iconsMap } from './UIDropdown.iconsMapping'
import type { UIFilterDropdownProps } from './UIFilterDropdown.props'
const { titleWrapper = 'span' } = defineProps<UIFilterDropdownProps>()
</script>
<template>
  <HeadlessDisclosure
    v-slot="{ open, close }"
    as="div"
    :default-open="defaultOpen"
  >
    <HeadlessDisclosureButton
      :id="clickId"
      class="flex w-full items-center py-6"
    >
      <div class="flex items-center gap-2">
        <span v-if="rightText">{{ rightText }}</span>
        <DefaultIconsRemove v-if="open" aria-hidden="true" class="h-4 w-4" />
        <DefaultIconsAdd v-else aria-hidden="true" class="h-4 w-4" />
      </div>
      <div class="flex gap-2">
        <component :is="iconsMap[icon]" v-if="icon" />
        <component
          :is="titleWrapper"
          v-if="title"
          id="title"
          class="title-subaccordion font uppercase"
        >
          {{ title }}
        </component>
      </div>
    </HeadlessDisclosureButton>
    <HeadlessTransitionRoot
      :show="open"
      enter="transition-all duration-500 overflow-hidden"
      enter-from="max-h-0"
      enter-to="max-h-screen"
      leave="transition-all duration-500 overflow-hidden"
      leave-from="max-h-screen"
      leave-to="max-h-0"
    >
      <HeadlessDisclosurePanel
        class="transition-all duration-300 ease-linear"
        :class="{
          'max-h-0 pb-0': close && isZipCode,
          'max-h-full pb-28': open && isZipCode,
          '!mb-0': isZipCode,
        }"
      >
        <div
          v-if="isZipCode"
          class="bg-primitives-grey-50 overflow-hidden transition-all duration-300 ease-linear"
          :class="{
            'absolute left-0 right-0 top-10 max-h-full w-full p-4 pb-6':
              open && isZipCode,
            'absolute left-0 right-0 top-10 max-h-0': close && isZipCode,
          }"
        >
          <slot />
        </div>
        <div v-else><slot /></div>
      </HeadlessDisclosurePanel>
    </HeadlessTransitionRoot>
  </HeadlessDisclosure>
</template>

<style scoped lang="scss">
.less-icon {
  width: 8px;
  height: 1px;
  margin-top: 10px;
  background-color: var(--colorBackgroundPrimary);
}
.title-subaccordion {
  font-size: 12px;
  font-weight: 400;
  line-height: 23px;
}
</style>
